module.exports = __webpack_public_path__ + "img/73.33526e20.jpg";